import { Box, Button, Checkbox, CircularProgress, FormControl, FormControlLabel, Grid, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { refresh } from '../features/auth/authSlice'
import { toast } from '../features/snackbar/snackbarSlice'
import Logo from '../Logo'
import { useGetUserInfoQuery, useLoginMutation } from '../services/api'
import { useRedirectUrl } from '../useRedirectUrl'

const Login = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const redirectUrl = useRedirectUrl()
  const [username, setUsername] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [rememberMe, setRememberMe] = useState<boolean>(false)
  const {
    data: user,
    isLoading: isLoadingUserInfo,
    refetch: refetchUserInfo
  } = useGetUserInfoQuery()
  const dispatch = useDispatch()
  const [
    login,
    { isLoading: isLoadingLogin },
  ] = useLoginMutation()

  const isLoading = isLoadingLogin || isLoadingUserInfo;

  useEffect(() => {
    if (user?.guid) {
      if (user?.role === 'member' && user?.memberType !== 'public' && !user?.verified)
        navigate(`/verify${user?.verificationId
          ? `?verificationId=${user?.verificationId}`
          : ''
          }`
        )
      else
        navigate(redirectUrl ?? '/dashboard')
    }
  }, [location.search, navigate, redirectUrl, user])

  const disabled = !username || !password || isLoading
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{
        minHeight: '100vh'
      }}
    >
      <Logo height={128} />
      <br />
      <Grid
        item
        xs={3}
      >
        Please login to access your account.
      </Grid>
      <br />
      <br />
      <Grid
        item
        xs={3}
      >
        <Box
          autoComplete="off"
          component="form"
          display='inline-grid'
          onSubmit={(e: any) => {
            e.preventDefault()
            login({
              username,
              password,
            })
              .unwrap()
              .then(data => {
                if (data?.access_token) {
                  dispatch(
                    refresh({
                      accessToken: data?.access_token,
                      refreshToken: data?.refresh_token,
                      rememberMe,
                    })
                  )
                  refetchUserInfo()
                }
              })
              .catch(err => {
                console.error(err)
                dispatch(
                  toast({
                    message: 'Login Unsuccessful',
                    severity: 'error',
                  })
                )
              })
          }}
          sx={{
            '& .MuiTextField-root': {
              mt: 1,
              minWidth: '25ch'
            },
          }}
        >
          <TextField
            autoComplete="current-username"
            autoFocus
            fullWidth
            label="Username or Email"
            onChange={e => setUsername(e.target.value)}
            required
            value={username}
          />
          <TextField
            autoComplete="current-password"
            fullWidth
            label="Password"
            onChange={e => setPassword(e.target.value)}
            type="password"
            required
            value={password}
          />
          <br />
          <FormControl
            fullWidth
            style={{ alignItems: 'center' }}
          >
            <FormControlLabel
              control={<Checkbox
                onChange={(_, checked) => setRememberMe(checked)}
              />}
              label='Remember me'
            />
          </FormControl>
          <br />
          <Button
            disabled={disabled}
            type='submit'
            variant="contained"
          >{isLoading
            ? <CircularProgress
              size={25}
            />
            : 'Login'
            }</Button>
          <br />
          <Box
            display='flex'
            justifyContent='space-between'
            fontSize={12}
          >
            <Link
              to={`/forgot${!redirectUrl ? '' : `?redirectUrl=${encodeURIComponent(redirectUrl)}`}`}
            >Forgot Password</Link>
            <a
              href={`/signup${!redirectUrl ? '' : `?redirectUrl=${encodeURIComponent(redirectUrl)}`}`}
            >Create New Account</a>
          </Box>
        </Box>
      </Grid>
    </Grid>
  )
}

export default Login